export const CHOOSER_SCRIPT_ID = 'dropboxjs'
export const CHOOSER_SCRIPT_SRC =
  'https://www.dropbox.com/static/api/2/dropins.js'
export const CHOOSER_TIMEOUT_MS = 15000

let chooserPromise
let chooserAppKey

// Preload outside the click handler. Dropbox.choose itself must run synchronously
// in the user gesture, not in a promise continuation.
export default function loadChooser(appKey) {
  if (typeof appKey !== 'string' || !appKey.trim()) {
    return Promise.reject(new Error('Dropbox app key is not configured'))
  }
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return Promise.reject(new Error('Dropbox Chooser requires a browser'))
  }
  const key = appKey.trim()
  if (chooserPromise) {
    if (chooserAppKey !== key) {
      return Promise.reject(new Error('Dropbox app key does not match'))
    }
    return chooserPromise
  }

  chooserAppKey = key
  const loading = new Promise((resolve, reject) => {
    let script = document.getElementById(CHOOSER_SCRIPT_ID)
    if (
      script &&
      (script.tagName !== 'SCRIPT' ||
        script.src !== CHOOSER_SCRIPT_SRC ||
        script.getAttribute('data-app-key') !== key)
    ) {
      reject(new Error('Existing Dropbox script does not match configuration'))
      return
    }

    const created = !script
    if (created) {
      script = document.createElement('script')
      script.id = CHOOSER_SCRIPT_ID
      script.src = CHOOSER_SCRIPT_SRC
      script.setAttribute('data-app-key', key)
      script.async = true
    }
    let timer
    let onLoad
    let onError
    const cleanup = () => {
      clearTimeout(timer)
      script.removeEventListener('load', onLoad)
      script.removeEventListener('error', onError)
    }
    const fail = message => {
      cleanup()
      if (script.parentNode) script.parentNode.removeChild(script)
      reject(new Error(message))
    }
    onLoad = () => {
      const sdk = window.Dropbox
      if (!sdk || typeof sdk.choose !== 'function') {
        fail('Dropbox Chooser did not initialize')
        return
      }
      if (
        typeof sdk.isBrowserSupported === 'function' &&
        !sdk.isBrowserSupported()
      ) {
        fail('Dropbox Chooser is not supported in this browser')
        return
      }
      cleanup()
      resolve(sdk)
    }
    onError = () => fail('Dropbox Chooser failed to load')
    script.addEventListener('load', onLoad)
    script.addEventListener('error', onError)
    timer = setTimeout(
      () => fail('Dropbox Chooser loading timed out'),
      CHOOSER_TIMEOUT_MS
    )
    if (window.Dropbox && typeof window.Dropbox.choose === 'function') {
      onLoad()
    } else if (created) {
      document.head.appendChild(script)
    }
  })
  chooserPromise = loading.catch(error => {
    chooserPromise = undefined
    chooserAppKey = undefined
    throw error
  })
  return chooserPromise
}
